'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.directive('rank', function () {
	return {
		restrict: 'EA',
		scope: {
			key: '@key'
		},
		link: function (scope, element, attrs) {

		},
		templateUrl: "rank/rankings.html",
//		controller: function ($scope, $http, $log) {
		controller: ['$scope', '$http', '$log', function ($scope, $http, $log) {
			$scope.rankUrl = jsRankConfig.rankUrl;
			$scope.sitekey = jsRankConfig.recaptcha.siteKey;
			$scope.rank = jsRankConfig.contentList[$scope.key];
			$scope.voted = false;
			$scope.loading = false;
			$scope.errors = [];
			$scope.rankData = {
				recaptchaResponse: null
			};

			$scope.hoverIn = function () {
				this.addClass = "selected";
			};

			$scope.rate = function (rate) {
				if (typeof grecaptcha !== 'undefined') {
					grecaptcha.ready(function () {
						if ($scope.sitekey) {
							$scope.loading = true;
							grecaptcha.execute($scope.sitekey, {action: 'submit'}).then(function (token) {
								//						document.getElementById('g-recaptcha-response-hidden').value = token;
								$scope.rankData.recaptchaResponse = token;
								$scope.submitRank(rate);
							});
						} else {
							$scope.voted = true;
							console.log("no recaptcha siteKey");
						}
					});
				} else {
					$scope.loading = false;
					console.log("no recaptcha service");
				}
			};
			$scope.checkEnter = function (event, rate) {
				if (event.key === "Enter") {
					$scope.rate(rate);
				}
			};
			$scope.submitRank = function (rate) {
				if ($scope.rankUrl !== '' && $scope.key) {
					let rank_data = {
						rate: rate,
						xsrfCookieName: secure_xsrf_name,
						xsrfHeaderName: 'X-' + secure_xsrf_name
					};
					if (typeof jsRankConfig.recaptcha !== 'undefined') {
						rank_data[jsRankConfig.recaptcha.field] = $scope.rankData.recaptchaResponse;
					}

					$http({
						method: 'POST',
						url: $scope.rankUrl + '?hash_key=' + $scope.key,
						data: rank_data
					}).then(function (response) {

						if (response.data.data.success) {
//							$scope.rank.average = response.data.data.avg;
							$scope.rank.total = response.data.data.total;
							$scope.rank.total_like = response.data.data.total_like;
							$scope.rank.total_dislike = response.data.data.total_dislike;
							$scope.rank.rate = response.data.data.rate;
						} else if (angular.isDefined(response.data.data.messages)) {
							$scope.errors = response.data.data.messages;
						}
						if (angular.isDefined(response.data.data.debug)) {
							$log.debug(response.data.data.debug);
						}
					}).then(function (response) {
						$scope.voted = true;
						$scope.loading = false;
					});
				}
			};
			$scope.hasErrors = function () {
				return $scope.errors.length > 0;
			};
		}]
	};
});